/** @arg {string} id */
export function selectInput(id) {
  const elm = document.getElementById(id);
  if (elm instanceof HTMLInputElement) return elm;
  throw new Error(`'${id}' element not found`);
}
